export const SUBDEALER_RELATION_UNDER_SOLDTO_REQUEST =
  "SUBDEALER_RELATION_UNDER_SOLDTO_REQUEST";
export const SUBDEALER_RELATION_UNDER_SOLDTO_SUCCESS =
  "SUBDEALER_RELATION_UNDER_SOLDTO_SUCCESS";
export const SUBDEALER_RELATION_UNDER_SOLDTO_FAILURE =
  "SUBDEALER_RELATION_UNDER_SOLDTO_FAILURE";
export const SUBDEALER_RELATION_UNDER_SOLDTO_LOADING =
  "SUBDEALER_RELATION_UNDER_SOLDTO_LOADING";

export const GET_SUB_DEALER_INFO_REQUEST = "GET_SUB_DEALER_INFO_REQUEST";
export const GET_SUB_DEALER_INFO_SUCCESS = "GET_SUB_DEALER_INFO_SUCCESS";
export const GET_SUB_DEALER_INFO_FAILURE = "GET_SUB_DEALER_INFO_FAILURE";
export const GET_SUB_DEALER_LOYALTY_TRANSACTION_LOADING =
  "GET_SUB_DEALER_LOYALTY_TRANSACTION_LOADING";
